import { useState, useEffect } from 'react';

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';

const breakpoints = {
    xs: 475,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1536,
} as const;

export const useBreakpoint = () => {
    const [currentBreakpoint, setCurrentBreakpoint] = useState<Breakpoint>('md');

    useEffect(() => {
        const updateBreakpoint = () => {
            const width = window.innerWidth;

            if (width >= breakpoints['2xl']) {
                setCurrentBreakpoint('2xl');
            } else if (width >= breakpoints.xl) {
                setCurrentBreakpoint('xl');
            } else if (width >= breakpoints.lg) {
                setCurrentBreakpoint('lg');
            } else if (width >= breakpoints.md) {
                setCurrentBreakpoint('md');
            } else if (width >= breakpoints.sm) {
                setCurrentBreakpoint('sm');
            } else {
                setCurrentBreakpoint('xs');
            }
        };

        updateBreakpoint();
        window.addEventListener('resize', updateBreakpoint);

        return () => window.removeEventListener('resize', updateBreakpoint);
    }, []);

    const isMobile = currentBreakpoint === 'xs' || currentBreakpoint === 'sm';
    const isTablet = currentBreakpoint === 'md';
    const isDesktop = currentBreakpoint === 'lg' || currentBreakpoint === 'xl' || currentBreakpoint === '2xl';

    const isAbove = (breakpoint: Breakpoint) => {
        const breakpointValues = Object.values(breakpoints);
        const currentIndex = breakpointValues.indexOf(breakpoints[currentBreakpoint]);
        const targetIndex = breakpointValues.indexOf(breakpoints[breakpoint]);
        return currentIndex >= targetIndex;
    };

    const isBelow = (breakpoint: Breakpoint) => {
        return !isAbove(breakpoint);
    };

    return {
        currentBreakpoint,
        isMobile,
        isTablet,
        isDesktop,
        isAbove,
        isBelow,
    };
};
